/**
 * 라커 화면들이 함께 쓰는 서버 에러 메시지 추출기.
 *
 * `api/client.ts` 가 던지는 에러에는 서버 본문의 message 가 `serverMessage` 로 붙는다.
 * 같은 함수가 라커 화면 세 곳에 복사돼 있어 한곳으로 모았다.
 */
export const getMutationErrorMessage = (error: any, fallback: string): string =>
    error?.serverMessage || error?.message || fallback;
